import { render } from "./BillingPeriod.vue?vue&type=template&id=77b24ad4&scoped=true"
import script from "./BillingPeriod.vue?vue&type=script&lang=js"
export * from "./BillingPeriod.vue?vue&type=script&lang=js"

import "./BillingPeriod.vue?vue&type=style&index=0&id=77b24ad4&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/studyflow-frontend/studyflow-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77b24ad4"]])

export default __exports__